<h1 mat-dialog-title>Preview</h1>
<div mat-dialog-content class="w-full h-full">
  <app-iframe-viewer
    [url]="data.url"
    [token]="data.token"
    [classContainer]="'powerbi-full-container'"
  ></app-iframe-viewer>
</div>
<button mat-icon-button mat-dialog-close class="absolute top-5 right-5">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-x"
  >
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
</button>
